export default "__VITE_ASSET__Do_dZl2B__"